// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4437 ? "0a33da26" : chunkId) + "." + {"2896":"19ad94e3e3dc363a","4437":"47cd9711a67fc9f4","8518":"748891c4af0ea01f","8957":"b43d9fccd1a86444"}[chunkId] + ".js";
};